import React, { useState } from "react";
import SectionTitle from "./SectionTitle";

export default function CollapseLabel({ children, name }) {
  const [tableVisible, setTableVisible] = useState(true);

  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  };

  return (
    <>
      <div
        className="col-12 right-to-left"
        
      >
        <div className="d-inline-block" onClick={toggleTableVisibility}>
          <SectionTitle section_name={name} noMargin ish3={true} isContainer={false} />
        </div>

        <div className="ms-2 d-inline-block" onClick={toggleTableVisibility}>
          {tableVisible ? (
            <i className="fa-solid fa-chevron-up"></i>
          ) : (
            <i className="fa-solid fa-chevron-down"></i>
          )}
        </div>
        {tableVisible && children}
      </div>

    </>
  );
}
